export default function RecordingOnIcon() {
  return (
    <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_63200_164064)'>
        <path
          d='M28.0003 4.66675C15.1203 4.66675 4.66699 15.1201 4.66699 28.0001C4.66699 40.8801 15.1203 51.3334 28.0003 51.3334C40.8803 51.3334 51.3337 40.8801 51.3337 28.0001C51.3337 15.1201 40.8803 4.66675 28.0003 4.66675ZM28.0003 46.6668C17.687 46.6668 9.33366 38.3134 9.33366 28.0001C9.33366 17.6867 17.687 9.33342 28.0003 9.33342C38.3137 9.33342 46.667 17.6867 46.667 28.0001C46.667 38.3134 38.3137 46.6668 28.0003 46.6668ZM37.3337 37.3334H18.667V18.6667H37.3337V37.3334Z'
          fill='#DA0808'
        />
      </g>
      <defs>
        <clipPath id='clip0_63200_164064'>
          <rect width='56' height='56' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
